import gsap from "gsap";
import Component from "../lib/Component";
import { addClass, hasClass, removeClass } from "../lib/Utils";

export default class Header extends Component {
	constructor() {
		super(".js-header");
	}

	initialize() {
		this.header = this.$el;

		this.DOM = {
			header: this.$el,
			headerInner: this.header.querySelector(".c-header__inner"),
			headerSpacer: document.querySelector(".js-header-space"),
			states: {
				headerScrolled: "has-scrolled",
				headerScrolledHalf: "has-scrolled--half",
				headerFixed: "is-fixed",
				headerSlideUp: "is-scrolling-down",
				headerSlideDown: "is-scrolling-up",
				isSpaceActive: true
			}
		};

		this.headerInitAnimation();

		this.headerInitScrolling();

		if (hasClass(document.querySelector("body"), "error404")) {
			this.DOM.states.isSpaceActive = false;
		}

		if (this.header !== null && this.DOM.states.isSpaceActive) {
			this.calculateHeaderSpace();

			this.onResize = () => this.calculateHeaderSpace();
			window.addEventListener("resize", this.onResize);
		}
	}

	headerInitAnimation() {
		const header = this.$el;
		const navigationStage = this.$$(".js-navigation-stage");
		const headerLine = this.$$(".js-header-line");
		const tl = gsap.timeline({ delay: 0.7 });

		tl.fromTo(header,
			{ opacity: 0 },
			{ opacity: 1, duration: 0.8, ease: "power4.out", stagger: 0.05 }
		);

		tl.fromTo(
			navigationStage,
			{ opacity: 0 },
			{ opacity: 1, duration: 1.5, ease: "power4.out", stagger: 0.2 },
			"-=0.5"
		);

		if (headerLine.length > 0) {
			tl.fromTo(
				headerLine,
				{
					transformOrigin: "0 0",
					width: 0
				},
				{
					opacity: 1,
					width: "100%",
					duration: 1
				},
				"-=0.5"
			);
		}

		tl.timeScale(2);
	}

	calculateHeaderSpace() {
		var $headerHeight = this.DOM.headerInner.offsetHeight;

		this.DOM.headerSpacer.style.height = `${$headerHeight}px`;
	}

	headerInitScrolling() {
		this.scrolling = false;

		this.previousTop = 0;
		this.scrollDelta = 0;
		this.scrollOffset = 0;

		this.scrollHeaderOffset = 2;

		this.header = this.DOM.header;

		if (this.header !== null) {
			this.headerController();
		}
	}

	headerController() {
		document.addEventListener("scroll", () => {
			if (!this.scrolling) {
				this.scrolling = true;

				if (!window.requestAnimationFrame) {
					setTimeout(this.checkScroll(), 250);
				} else {
					requestAnimationFrame(() => this.checkScroll());
				}
			}
		});
	}

	checkScroll() {
		let currentTop = window.pageYOffset | document.body.scrollTop;

		if (this.header != null) {
			this.changeHeaderState(currentTop);
		}

		this.previousTop = currentTop;
		this.scrolling = false;
	}

	changeHeaderState(currentTop) {
		if (currentTop > this.scrollHeaderOffset / 2) {
			addClass(this.header, this.DOM.states.headerScrolledHalf);
		}

		if (currentTop > this.scrollHeaderOffset) {
			addClass(this.header, this.DOM.states.headerScrolled);
		} else {
			removeClass(this.header, this.DOM.states.headerScrolled);
		}

		if (this.previousTop >= currentTop) {
			this.scrollingUp(currentTop);
		} else {
			this.scrollingDown(currentTop);
		}
	}

	scrollingUp(currentTop) {
		if (currentTop < this.scrollHeaderOffset / 2) {
			removeClass(this.header, this.DOM.states.headerScrolledHalf);
			removeClass(this.header, this.DOM.states.headerSlideDown);
		}

		if (currentTop < this.scrollHeaderOffset) {
			removeClass(this.header, this.DOM.states.headerSlideUp);
		} else if (this.previousTop - currentTop > this.scrollDelta) {
			removeClass(this.header, this.DOM.states.headerSlideUp);
			addClass(this.header, this.DOM.states.headerSlideDown);
		}
	}

	scrollingDown(currentTop) {
		if (currentTop > this.scrollHeaderOffset / 2) {
			addClass(this.header, this.DOM.states.headerScrolledHalf);
		}

		if (currentTop > this.scrollHeaderOffset + this.scrollOffset) {
			addClass(this.header, this.DOM.states.headerSlideUp);
			removeClass(this.header, this.DOM.states.headerSlideDown);
		} else if (currentTop > this.scrollHeaderOffset) {
			removeClass(this.header, this.DOM.states.headerSlideUp);
			addClass(this.header, this.DOM.states.headerSlideDown);
		}
	}
}
